import React from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./ValueComparison.css"; // Import the CSS file

const ValueComparison = () => {
  return (
    <FadeInSection className="value-comparison-container">

    <h2 className="value-comparison-title">
      Don’t Miss Out on Your AI Future
    </h2>

    <div className="value-comparison-grid">
      {/* Column 1 - If You Build From Scratch */}
      <div className="value-column">
        <h3 className="value-column-title">Without Modlee</h3>
        <ul className="value-list">
          <li className="value-item ❌">Struggling with complex data pipelines</li>
          <li className="value-item ❌">Limited scalability of AI agents</li>
          <li className="value-item ❌">Spending time managing systems, not innovating</li>
          <li className="value-item ❌">Missing automation and growth opportunities</li>
          <li className="value-item ❌">Losing out on AI-driven opportunities</li>
        </ul>
      </div>

      {/* Column 2 - With Modlee */}
      <div className="value-column">
        <h3 className="value-column-title">With Modlee</h3>
        <ul className="value-list">
          <li className="value-item ✅">Unlock immediate value with Data Agents</li>
          <li className="value-item ✅">Scale AI effortlessly as your business grows</li>
          <li className="value-item ✅">Free up your team to focus on high-impact work</li>
          <li className="value-item ✅">Embrace automation to boost efficiency</li>
          <li className="value-item ✅">Drive growth, profitability, and a competitive edge</li>
        </ul>
      </div>
    </div>

    <h2 className="value-comparison-subtitle">
      The future of your business is here. Let Modlee help you seize it.
    </h2>

    </FadeInSection>
  );
};

export default ValueComparison;
